export default __webpack_public_path__ + "3889a3e5ab2d6242f4758a88b18cabce.svg";